import { render } from "./ModalEditDepartment.vue?vue&type=template&id=483aec5e&scoped=true"
import script from "./ModalEditDepartment.vue?vue&type=script&lang=js"
export * from "./ModalEditDepartment.vue?vue&type=script&lang=js"

import "./ModalEditDepartment.vue?vue&type=style&index=0&id=483aec5e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483aec5e"]])

export default __exports__